import PropTypes from 'prop-types';
import React from 'react';

/**
 * Review rendering for pages that show read-only values. Used as a
 * `ui:objectViewField` for prefill confirmation pages, where the on-file values
 * (which live outside the page's visible fields) render above the page's
 * rendered properties, and directly as a `CustomPageReview`. The edit button
 * renders only when `defaultEditButton` is provided.
 */
const PrefillConfirmationReview = ({
  defaultEditButton,
  renderedProperties,
  rows,
  title,
}) => (
  <>
    <div className="form-review-panel-page-header-row">
      <h3 className="form-review-panel-page-header vads-u-font-size--h5">
        {title}
      </h3>
      {defaultEditButton && (
        <div className="vads-u-justify-content--flex-end">
          {defaultEditButton()}
        </div>
      )}
    </div>
    <dl className="review">
      {rows.map(({ label, value }) => (
        <div key={label} className="review-row">
          <dt>{label}</dt>
          <dd className="dd-privacy-hidden" data-dd-action-name={label}>
            {value}
          </dd>
        </div>
      ))}
      {renderedProperties}
    </dl>
  </>
);

PrefillConfirmationReview.propTypes = {
  defaultEditButton: PropTypes.func,
  renderedProperties: PropTypes.node,
  rows: PropTypes.arrayOf(
    PropTypes.shape({
      label: PropTypes.string,
      value: PropTypes.node,
    }),
  ),
  title: PropTypes.node,
};

export default PrefillConfirmationReview;
